import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  type DividendCalendar,
  type ManualEntryInput,
  type RefreshResult,
  dividendsApi,
} from "../lib/dividends";

const baseKey = ["dividends"] as const;

export function useDividendCalendarRange(range: { from: string; to: string }) {
  return useQuery<DividendCalendar>({
    queryKey: [...baseKey, "calendar", "range", range.from, range.to],
    queryFn: () => dividendsApi.getCalendar(range),
    staleTime: 60 * 60 * 1000,
  });
}

function invalidateAll(qc: ReturnType<typeof useQueryClient>) {
  return qc.invalidateQueries({ queryKey: baseKey });
}

export function useRefreshDividends() {
  const qc = useQueryClient();
  return useMutation<RefreshResult>({
    mutationFn: () => dividendsApi.refresh(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useCreateManualDividend() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: ManualEntryInput) => dividendsApi.createManual(input),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useDeleteManualDividend() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => dividendsApi.deleteManual(id),
    onSuccess: () => invalidateAll(qc),
  });
}
